module.exports = __webpack_public_path__ + "img/Acmi_4.e073bc46.gif";